import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faUser,
  faCircle as farCircle,
  faDotCircle,
  faCreditCard,
  faTimesCircle,
  faBookmark,
} from '@fortawesome/free-regular-svg-icons'
import { faFacebookSquare, faGoogle } from '@fortawesome/free-brands-svg-icons'
import {
  faPlus,
  faTrash,
  faHistory,
  faBezierCurve,
  faExternalLinkAlt,
  faUserShield,
  faTimesCircle as fasTimesCircle,
  faMoneyBillAlt,
  faBuilding,
  faBalanceScaleLeft,
  faBalanceScale,
  faStar,
  faEye,
  faEyeSlash,
  faPencilAlt,
  faSearch,
  faPlusCircle,
  faSearchPlus,
  faSearchMinus,
  faCircle,
  faCaretLeft,
  faCaretRight,
  faCaretDown,
  faUserCog,
  faCaretUp,
  faFile,
  faChevronDown,
  faChevronRight,
  faChevronLeft,
  faChevronCircleLeft,
  faChevronCircleRight,
  faChevronUp,
  faUserCircle,
  faUserEdit,
  faCog,
  faEllipsisH,
  faTimes,
  faExclamationCircle,
  faIdBadge,
  faAngleDown,
  faCaretSquareDown,
  faSignOutAlt,
  faMoneyCheck,
  faInfoCircle,
  faUsers,
  faCheck,
  faTrophy,
  faSackDollar,
  faDollarSign,
  faDumbbell,
  faArrowLeft,
  faCalendar,
  faCalendarAlt,
  faBookmark as fasBookmark,
  faDownload,
  faEnvelope,
} from '@fortawesome/free-solid-svg-icons'

export default {
  setup() {
    library.add(
      farCircle,
      faDotCircle,
      faPlus,
      faCreditCard,
      faTrash,
      faHistory,
      faStar,
      faBezierCurve,
      faExternalLinkAlt,
      faBuilding,
      faUserShield,
      fasTimesCircle,
      faMoneyBillAlt,
      faBalanceScaleLeft,
      faBalanceScale,
      faPencilAlt,
      faCheck,
      faUserEdit,
      faPlusCircle,
      faInfoCircle,
      faTrophy,
      faSackDollar,
      faMoneyCheck,
      faUsers,
      faUser,
      faEye,
      faEyeSlash,
      faSearch,
      faSearchPlus,
      faSearchMinus,
      faCircle,
      faCaretLeft,
      faCaretRight,
      faCaretDown,
      faCaretUp,
      faFile,
      faChevronDown,
      faChevronRight,
      faChevronLeft,
      faChevronUp,
      faUserCircle,
      faTimesCircle,
      faCog,
      faUserCog,
      faEllipsisH,
      faTimes,
      faExclamationCircle,
      faIdBadge,
      faAngleDown,
      faCaretSquareDown,
      faSignOutAlt,
      faChevronCircleLeft,
      faChevronCircleRight,
      faFacebookSquare,
      faGoogle,
      faDollarSign,
      faDumbbell,
      faArrowLeft,
      faCalendar,
      faCalendarAlt,
      faBookmark,
      fasBookmark,
      faDownload,
      faEnvelope
    )
  },
}
